import { type ReactElement, type ReactNode, useRef } from 'react';

import { Box, ClickAwayListener, Slide, Stack, styled } from '@mui/material';

import { useSidebar } from '../hooks';

const SubMenuSidebar = styled(Box)(({ theme }) => ({
  width: 240,
  height: '100vh',
  backgroundColor: theme.palette.horizonGray4.main,
  zIndex: 18,
  position: 'absolute',
  top: 0,
  right: -240,
}));

type SubMenuContainerProps = {
  children: ReactNode;
};

export const SubMenuContainer = ({
  children,
}: SubMenuContainerProps): ReactElement => {
  const { shouldShowSubMenu, hideSubMenu, resetSubMenu } = useSidebar();
  const subMenuContainerRef = useRef(null);

  return (
    <ClickAwayListener onClickAway={hideSubMenu}>
      <Slide
        in={shouldShowSubMenu}
        direction="right"
        mountOnEnter
        unmountOnExit
        timeout={300}
        container={subMenuContainerRef.current}
        onExited={resetSubMenu}
      >
        <SubMenuSidebar component="nav">
          <Stack spacing={3}>{children}</Stack>
        </SubMenuSidebar>
      </Slide>
    </ClickAwayListener>
  );
};
